import './App.css';
import Tasks from './compnets/Tasks';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { TaskProvider } from './Context/TaskContex';
import Typography from '@mui/material/Typography';

// test
// import Test from './Test';
const customTheme = createTheme({
  typography: {
    fontFamily: [
      'Alex', // اسم الخط المخصص أولاً
    ]
  },
   palette: {
    primary:{
     main: '#009688'
    } ,
    secondary: {
      main: '#ff5722',
    },
  },
});
function App() {
  return (
    <ThemeProvider theme={customTheme}>
    <div className="App" style={
      {display:"flex",
     justifyContent:"center",
    alignItems:"center",
    backgroundColor:"#e5e5e5",
     height:"100vh",
     direction:"rtl",
     fontFamily: "Alex", 
     }}>
     <TaskProvider>
    <Tasks/>
    </TaskProvider>
    </div>
<Typography 
  variant="body2" 
  sx={{ 
    textAlign: 'center', 
    marginTop: '30px', 
    marginBottom: '10px',
    color: '#757575', // لون رمادي هادئ
    fontFamily: 'Alexandria', // نفس الخط الذي تستخدمه في "مهامي"
    opacity: 0.8 
  }}
>
 **Gemo** تم الصنع بواسطة 
</Typography>
    </ThemeProvider>
  );
}

export default App;
